import { MBFooter } from '@mercedes-benz/mbui-comps';
import { Box, useTheme } from '@mui/material';
import { useRef, useState } from 'react';
import { AppConfig } from '../../app/AppConfig';
import { PageContainer } from './PageContainer';
import { PageNavBar } from './PageNavBar';
import { SidebarDrawer } from './SideBarDrawer';

const PageLayout = ({ children }) => {
  const refSidebarBox = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const theme = useTheme();

  const navBarHeight = '64px';

  const openNavigation = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: theme.palette.background.default,
      }}
    >
      <PageNavBar onMenuBtnClick={() => openNavigation()} />
      <Box
        ref={refSidebarBox}
        sx={{
          position: 'fixed',
          marginTop: navBarHeight,
          overflow: 'hidden',
          display: 'none',
          zIndex: 1,
          backgroundColor: theme.palette.background.default,
          left: 0,
          width: AppConfig.sideBarWidth,
        }}
      >
        <SidebarDrawer openNavigation={openNavigation} menuOpen={menuOpen} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: '1 0 auto', // Allows the container to grow and take available space
          marginLeft: 0,
          width: '100%',
          backgroundColor: theme.palette.background.default,
        }}
      >
        <PageContainer>{children}</PageContainer>
      </Box>
      <Box sx={{ flexShrink: 0 }}>
        <MBFooter
          rightsReservedText={
            '\u00a9 2024 Mercedes-Benz Group AG. All rights reserved.'
          }
          privacyProtectionInfoLink={'#/cookiesuse'}
          legalNoticeInfoLink={'#/dpnotice'}
          providerInfoLink={'https://group.mercedes-benz.com/provider/?r=dai'}
          cookieInfoLink={'#/cookie'}
        />
      </Box>
    </Box>
  );
};

PageLayout.propTypes = {};

PageLayout.defaultProps = {};

export { PageLayout };
